import { CircularProgress } from '@mui/material'
import { FC } from 'react'
import { IBtnUiKitProps } from './interfaces'
import { ButtonUiKitStyled } from './styles'

const ButtonUiKit: FC<IBtnUiKitProps> = ({ children, loading, ...props }) => {
  return (
    <ButtonUiKitStyled variant='contained' size="small" disabled={loading} sx={loading?{background:'#a8a8a8 !important'}:{}}  {...props} >
      {children}
      {loading && <CircularProgress sx={{color:'#fff'}} size={20} className="mr-3" />}
    </ButtonUiKitStyled>
  )
}

export default ButtonUiKit
